<div class="card">
    <div class="p-grid">
        <div class="p-col-12">
            <p-menu #configmenu id="config_menu" [model]="configMenuItemsCM" [popup]="true"></p-menu>
            <div class="tabviewIcons p-mr-2">
                <div class="btnBars" (click)="refreshDetails()">
                    <i class="pi pi-refresh"></i>
                </div>
                <div class="btnBars" (click)="configmenu.toggle($event)">
                    <i class="pi pi-bars"></i>
                </div>
                <div class="btnBars" (click)="closeSplitView()">
                    <i class="pi pi-times"></i>
                </div>
            </div>
            <p-tabView  (onChange)="changeTab($event)" [(activeIndex)]="selectedTabIndex">
                <p-tabPanel header="Overview">
                    <div *ngIf="workflowDetails" class="workflow-scheduler">
                        <div class="workflow-occurrence p-mr-3">
                            <strong>Occurrence:</strong>
                            <ng-container *ngIf="workflowDetails?.occurrenceType===scheduleTypesEnum.Once">
                                Once <ng-container *ngIf="workflowDetails.scheduledDate"><span class="p-ml-2">|</span><strong class="p-ml-2">Scheduled Time:</strong> {{ workflowDetails.scheduledDate | localDate:'MM/DD/YYYY | h:mm a' }}</ng-container>
                            </ng-container>
                            <ng-container *ngIf="workflowDetails?.occurrenceType!==scheduleTypesEnum.Once">
                                Every {{ workflowDetails.occurrenceValue }} {{ workflowOccurrenceTypes[workflowDetails.occurrenceBase] }}
                            </ng-container>
                        </div>

                        <div *ngIf="workflowDetails?.lastStartDate" class="workflow-occurrence p-mr-3">
                            <strong>Last Execution Time:</strong> {{ workflowDetails.lastStartDate | localDate:'MM/DD/YYYY | h:mm a' }}
                        </div>

                        <div *ngIf="workflowDetails?.occurrenceType!==scheduleTypesEnum.Once && workflowDetails?.nextStartDate && (executionStatus==workflowExecutionStatus.Pending || executionStatus!=workflowExecutionStatus.Executing)" class="workflow-occurrence">
                            <strong>Next Execution Time:</strong> {{ workflowDetails.nextStartDate | localDate:'MM/DD/YYYY | h:mm a' }}
                        </div>

                        <div class="workflow-scheduler-status">
                            <strong class="p-mr-1">Execution Status:</strong> {{ workflowExecutionStatus[executionStatus] }}

                            <span [pTooltip]="workflowValidExpired ? workflowValidExpiredText : (workflowDetails.statusId==1 ? 'Run Workflow Scheduler' : 'Scheduler disabled for inactive workflows')" tooltipPosition="top">
                                <button *ngIf="executionStatus==workflowExecutionStatus.Pending || !workflowJobId" [disabled]="workflowDetails.statusId!=1 || workflowValidExpired" (click)="runWorkflowTaskScheduler()" [loading]="taskSchedulerSubmitLoading" pButton type="button" class="p-ml-2" label="Run Scheduler"></button>
                            </span>
                            <button *ngIf="executionStatus!=workflowExecutionStatus.Pending && workflowJobId" [disabled]="!workflowExecutionStatus.Executed" (click)="stopWorkflowTaskScheduler()" [loading]="taskSchedulerSubmitLoading" [pTooltip]="workflowJobId ? 'Stop Workflow Scheduler' : 'No Job Id Found'" tooltipPosition="top" pButton type="button" class="p-button-danger p-ml-2" label="Stop Scheduler"></button>
                        </div>
                    </div>
                    <app-shared-detail-block [column]="detailsBlockCols" [data]="selectedWorkflowBlock" [moduleName]="'WorkFlow'">
                    </app-shared-detail-block>

                    <p-divider class="y_padding"></p-divider>

                    <div class="header p-d-flex p-jc-between" style="position: relative; height: 43px;">
                        <h5 class="p-mt-2">Conditions</h5>
                    </div>

                    <ng-container *ngTemplateOutlet="conditionDetailsTemplate; context: { conditionGroupDetails: conditionGroup, workflowDetailsView: true, filterMode: true  }"></ng-container>

                </p-tabPanel>
                <p-tabPanel header="History">
                    <div *ngIf="selectedTabIndex==1" class="workflow-history">
                        <div class="workflowhistory-filters">
                            <p-dropdown [options]="actionTypeList" [(ngModel)]="selectedActionType" (onChange)="filterByActionType()" [showClear]="false" appendTo="body" placeholder="Filter By Action Type" optionLabel="name"></p-dropdown>
                            <p-dropdown class="p-ml-2" [options]="executionStatusList" [(ngModel)]="selectedExecutionStatus" (onChange)="filterByExecutionStatus()" [showClear]="false" appendTo="body" placeholder="Filter By Status" optionLabel="name"></p-dropdown>
                        </div>
                        <div class="card">
                            <p-table #workflowHisoryTable [columns]="historyCols" [value]="workflowHistoryResults"
                            selectionMode="single" [(selection)]="selectedHistory" dataKey="id" responsiveLayout="scroll"
                            (onRowSelect)="onRowSelect($event);"
                            (onRowUnselect)="onRowUnselect($event)"
                            [lazy]="true" (onLazyLoad)="getWorkflowHistoryByFilter($event)"
                            [paginator]="true" [rows]="pageSize" [totalRecords]="totalRecords" [(first)]="first"
                            [showCurrentPageReport]="true"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                            [rowsPerPageOptions]="tableShowMore">
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                    <ng-container *ngFor="let col of columns">
                                        <col *ngIf="col.show" style="width:auto">
                                    </ng-container>
                                    </colgroup>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                      <ng-container *ngFor="let col of columns">
                                        <th *ngIf="col.show" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                                ariaLabelDesc="Activate to sort in descending order"
                                                ariaLabelAsc="Activate to sort in ascending order">
                                            </p-sortIcon>
                                            <!-- <span class="pi pi-filter p-ml-2 filtericon"
                                                [ngClass]="{'blink_me' : col.value.length > 0}"
                                                (click)="$event.stopPropagation(); curCol = col; op.toggle($event)">
                                            </span> -->
                                        </th>
                                      </ng-container>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                                        <ng-container *ngFor="let col of columns">
                                            <td *ngIf="col.show" style="text-align: left;">
                                                <ng-container [ngSwitch]="col?.dataType">
                                                    <ng-container *ngSwitchCase="'date'">
                                                        <div>
                                                            {{ rowData[col.field] | localDate:'MM/DD/YYYY | h:mm a' }}
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngSwitchCase="'string'">
                                                        <div *ngIf="col.value=='duration'" pTooltip="{{rowData[col.field]}}" tooltipPosition="top">
                                                            {{ (rowData?.filterFromDate && rowData.filterToDate)? (rowData?.filterFromDate | localDate:'MM/DD/YYYY | h:mm a') +' - '+  (rowData?.filterToDate | localDate:'MM/DD/YYYY | h:mm a') : '' }}
                                                        </div>
                                                        <div *ngIf="col.value!='duration'" pTooltip="{{rowData[col.field]}}" tooltipPosition="top">
                                                            {{ rowData[col.field] }}
                                                        </div>
                                                    </ng-container>
                                                    <ng-container *ngSwitchDefault>
                                                        <div>
                                                            {{ rowData[col.field] }}
                                                        </div>
                                                    </ng-container>
                                                </ng-container>
                                            </td>
                                        </ng-container>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="6">{{noWfFindOrLoadingText}}</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                            <p-overlayPanel #op [showCloseIcon]="false" [dismissable]="true">
                                <ng-template pTemplate>
                                  <input pInputText type="text" #inputS [(ngModel)]="curCol.value"
                                    (input)="workflowHisoryTable.filter(curCol.value, curCol.field, 'contains')"
                                    placeholder="Search by {{curCol.header}}" class="p-column-filter"
                                    [value]="workflowHisoryTable.filters[curCol.field] ? workflowHisoryTable.filters[curCol.field].value : ''">
                                </ng-template>
                            </p-overlayPanel>
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
    </div>
</div>

<!-- <p-confirmDialog [style]="{width: '20vw'}" [baseZIndex]="1000000"></p-confirmDialog> -->

<!-- Condition Details Start -->
<ng-template #conditionDetailsTemplate let-conditionGroupDetails="conditionGroupDetails" let-workflowDetailsView="workflowDetailsView" let-filterMode="filterMode">
    <div class="card" *ngIf="workflowDetails">
        <ng-container *ngFor="let addedCondition of conditionGroupDetails|statusFilter:filterMode; let i = index;">
            <p-panel [toggleable]="true" [iconPos]="left" class="condition-details row-reverse">
                <ng-template pTemplate="header">
                    <div class="p-d-flex w-100 p-pl-3">
                        <h6 class="p-mb-0 p-mt-2" style="flex-grow: 1;">
                            Condition {{ addedCondition?.conditionNumber }} ({{ addedCondition.type == 'savedsearch' ? 'Saved Search Rules' : 'Manual Rules' }})

                            <span *ngIf="!addedCondition?.validData && addedCondition?.errorMsg" class="p-invalid pml-3"><small>{{ addedCondition.errorMsg }}</small></span>
                        </h6>
                    </div>
                </ng-template>
                <ng-container *ngIf="addedCondition?.ruleData?.length > 0">
                    <div class="p-field p-grid">
                        <div class="p-col-12">
                            <app-saved-search-added-rules-table
                                [isDisabled]="true"
                                [ruleData]="addedCondition.ruleData"
                                [ruleCombination]="addedCondition.ruleCombination"
                                [isCombinational]="addedCondition.isCombinational">
                            </app-saved-search-added-rules-table>
                        </div>
                    </div>

                    <div *ngIf="addedCondition?.instantActions" class="header p-d-flex p-jc-between" style="position: relative; height: 43px;">
                        <h5 class="p-mt-2">Instant Actions</h5>
                    </div>

                    <div class="card" *ngIf="addedCondition?.instantActions">
                        <p-table *ngIf="checkActions(addedCondition?.instantActions)">
                            <ng-template pTemplate="header">
                            <tr>
                                <th class="workflow-action-type">Action Type</th>
                                <th style="width: auto">Description</th>
                                <th class="workflow-action-type" class="action p-text-right">Action</th>
                            </tr>
                            </ng-template>
                        </p-table>

                        <div>
                            <ng-container *ngFor="let actionOrder of addedCondition?.instantActions?.executionOrders">
                                <div *ngIf="addedCondition?.instantActions?.[actionOrder.code]?.length>0">
                                    <div class="action-list-wrapper">
                                        <h6 class="drag-section-label">
                                            <i class="pi pi-bars p-mr-3" style="color: lightgray"></i>{{actionOrder.name}}
                                        </h6>
                                        <div *ngIf="!actionOrder?.collapsed && !addedCondition?.instantActions?.hideContent">
                                            <ng-container [ngSwitch]="actionOrder.code">
                                                <ng-container *ngSwitchCase="'workflowActionTasks'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionTasks">
                                                        <ng-template pTemplate="body" let-taskDetails let-index="rowIndex">
                                                            <tr>
                                                                <td class="workflow-action-type">Task</td>
                                                                <td style="width: auto">{{ taskDetails?.taskTypeId==2 ? taskDetails?.taskTitle||'Group Task' : taskDetails?.taskTitle||taskDetails.description }}</td>
                                                                <td class="workflow-action-type" class="action p-text-right">

                                                                    <span class="btnBars p-mr-2" (click)="openTaskEdit(addedCondition,'instant',-1,taskDetails, index)">
                                                                        <i class="pi pi-eye"></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'workflowActionEmails'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionEmails">
                                                        <ng-template pTemplate="body" let-emailDetails let-index="rowIndex">
                                                            <tr>
                                                                <td class="workflow-action-type">
                                                                    {{emailDetails.notificationType==notificationTypeEnum.WHATSAPP ? 'Whatsapp Alert' : 'Email Alert'}} ({{ emailDetails.objectName }})
                                                                </td>
                                                                <td style="width: auto">{{ emailDetails.notificationType==notificationTypeEnum.WHATSAPP ? (emailDetails.body | removeHtmlTags | shorten:50) : emailDetails.subject }}</td>
                                                                <td class="workflow-action-type" class="action p-text-right">

                                                                    <span class="btnBars p-mr-2" (click)="openEmailEdit(addedCondition,'instant',-1,emailDetails, index)">
                                                                        <i class="pi pi-eye"></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'workflowActionCreateRecords'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionCreateRecords">
                                                        <ng-template pTemplate="body" let-recordDetails let-index="rowIndex">
                                                            <tr>
                                                                <td class="workflow-action-type">Create Record</td>
                                                                <td style="width: auto">Module: <strong>{{ recordDetails?.objectName }} {{ recordDetails?.channelName ?'('+recordDetails?.channelName+')':'' }}</strong></td>
                                                                <td class="workflow-action-type" class="action p-text-right">

                                                                    <span class="btnBars p-mr-2" (click)="openCreateRecordEdit(addedCondition,'instant',-1,recordDetails, index)">
                                                                        <i class="pi pi-eye"></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'workflowActionUpdateRecords'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionUpdateRecords">
                                                        <ng-template pTemplate="body" let-recordDetails let-index="rowIndex">
                                                            <tr>
                                                                <td class="workflow-action-type">Update Record ({{ recordDetails.objectName }})</td>
                                                                <td style="width: auto">Update Type: <strong>{{ workflowUpdateRecordOfferTypes[recordDetails.offerType] }}</strong></td>
                                                                <td class="workflow-action-type" class="action p-text-right">

                                                                    <span class="btnBars p-mr-2" (click)="openUpdateRecordEdit(addedCondition,'instant',-1,recordDetails, index)">
                                                                        <i class="pi pi-eye"></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'workflowActionUpdateFields'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionUpdateFields">
                                                        <ng-template pTemplate="body" let-fieldDetails let-index="rowIndex">
                                                            <tr>
                                                                <td class="workflow-action-type">Update Field ({{fieldDetails?.objectName}})</td>
                                                                <td style="width: auto">Field: <strong>{{ fieldDetails?.labelName||fieldDetails.fieldName }}</strong> | {{ fieldDetails?.operationType | workflowUFOT }} Value: <strong>{{ fieldDetails | wfUFValue | removeHtmlTags | shorten }}</strong></td>
                                                                <td class="workflow-action-type" class="action p-text-right">

                                                                    <!-- <span class="btnBars p-mr-2" (click)="openFieldEdit(addedCondition,'instant',-1,fieldDetails, index)">
                                                                        <i class="pi pi-eye"></i>
                                                                    </span> -->
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'workflowActionApprovals'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionApprovals | wfApprovalsGroup">
                                                        <ng-template pTemplate="body" let-approvalDetails let-index="rowIndex">
                                                            <tr>
                                                                <td class="workflow-action-type">Approvals for ({{ approvalDetails.objectName }})</td>
                                                                <td style="width: auto"><strong>{{ approvalDetails.count }}</strong> Approver Added</td>
                                                                <td class="workflow-action-type" class="action p-text-right">

                                                                    <span class="btnBars p-mr-2" (click)="openApprovalEdit(addedCondition,'instant',-1,approvalDetails?.workflowActionApprovals)">
                                                                        <i class="pi pi-eye"></i>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'workflowActionConvertToInvoices'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionConvertToInvoices">
                                                        <ng-template pTemplate="body" let-fieldDetails let-index="rowIndex">
                                                            <tr>
                                                                @if(workflowConversionTypeNames[fieldDetails?.conversionType]  === 'Item Receipt') {
                                                                    <td class="workflow-action-type">{{ workflowConversionTypeNames[fieldDetails?.conversionType] }}</td>
                                                                    <td style="width: auto">Action: <strong>{{ fieldDetails.objectName }} {{workflowConversionTypeNames[fieldDetails?.conversionType]}}</strong></td>
                                                                    <td>                                                                   
                                                                        <p-checkbox [(ngModel)]="fieldDetails.billStatus"
                                                                        label="Receive Items With Bill" binary="true"
                                                                        class="p-mt-1" variant="filled" [disabled]="true"
                                                                        inputId="billStatus">
                                                                        </p-checkbox>                                                                  
                                                                    </td>
                                                                }@else {
                                                                    <td class="workflow-action-type">Convert to {{ workflowConversionTypeNames[fieldDetails?.conversionType] }}</td>
                                                                    <td style="width: auto">Action: <strong>{{ fieldDetails.objectName }} Convert to {{ workflowConversionTypeNames[fieldDetails?.conversionType] }}</strong></td>
                                                                }
                                                                <td class="workflow-action-type" class="action p-text-right"></td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                                <ng-container *ngSwitchCase="'workflowActionDeleteRecords'">
                                                    <p-table [value]="addedCondition?.instantActions?.workflowActionDeleteRecords">
                                                        <ng-template pTemplate="body" let-fieldDetails let-index="rowIndex">
                                                            <tr>
                                                                <td class="workflow-action-type">Delete Records ({{ fieldDetails?.objectName }})</td>
                                                                <td style="width: auto">Action: <strong>{{ deleteRecordStatusNames[fieldDetails?.changeStatus||0] }} all matched records</strong></td>
                                                                <td class="workflow-action-type" class="action p-text-right"></td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>

                        <ng-container *ngIf="!checkActions(addedCondition?.instantActions)">
                            <div class="p-text-center p-y-2">No Instant Actions Added!</div>
                        </ng-container>
                    </div>

                    <div *ngIf="workflowDetails?.triggerType!=workflowTriggerTypeEnum.CREATED_EDITED && addedCondition?.timeDependentActions" class="header p-d-flex p-jc-between p-mt-4" style="position: relative; height: 43px;">
                        <h5 class="p-mt-2">Time-Dependent</h5>
                    </div>

                    <ng-container *ngIf="workflowDetails?.triggerType!=workflowTriggerTypeEnum.CREATED_EDITED && addedCondition?.timeDependentActions">
                        <ng-container *ngFor="let dependentAction of addedCondition.timeDependentActions;let i = index;">
                            <div class="card">
                                <div class="p-d-flex p-jc-between" [class.p-mt-5] = "i>0">
                                    <div class="p-d-flex">
                                        <p>{{dependentAction.occurrenceValue}} {{dependentAction.occurrenceBaseName}} {{dependentAction.addOrSubstractBaseName}} {{dependentAction.dateTimeFieldLabel}}</p>
                                    </div>
                                </div>

                                <div>
                                    <p-table *ngIf="checkActions(dependentAction)">
                                        <ng-template pTemplate="header">
                                        <tr>
                                            <th class="workflow-action-type">Action Type</th>
                                            <th style="width: auto">Description</th>
                                            <th class="workflow-action-type" class="action p-text-right">Action</th>
                                        </tr>
                                        </ng-template>
                                    </p-table>

                                    <div>
                                        <ng-container *ngFor="let actionOrder of dependentAction?.executionOrders">
                                            <div *ngIf="dependentAction?.[actionOrder.code]?.length>0">

                                                <div class="action-list-wrapper">
                                                    <h6 class="drag-section-label">
                                                        <i class="pi pi-bars p-mr-3" style="color: lightgray"></i>{{actionOrder.name}}
                                                    </h6>

                                                    <div *ngIf="!actionOrder?.collapsed && !dependentAction?.hideContent">
                                                        <ng-container [ngSwitch]="actionOrder.code">
                                                            <ng-container *ngSwitchCase="'workflowActionTasks'">
                                                                <p-table [value]="dependentAction?.workflowActionTasks||[]">
                                                                    <ng-template pTemplate="body" let-taskDetails let-index="rowIndex">
                                                                        <tr>
                                                                            <td class="workflow-action-type">Task</td>
                                                                            <td style="width: auto">{{ taskDetails?.taskTypeId==2 ? taskDetails?.taskTitle||'Group Task' : taskDetails?.taskTitle||taskDetails.description }}</td>
                                                                            <td class="workflow-action-type" class="action p-text-right">

                                                                                <span class="btnBars p-mr-2" (click)="openTaskEdit(addedCondition,'timedependent',i,taskDetails, index)">
                                                                                    <i class="pi pi-eye"></i>
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'workflowActionEmails'">
                                                                <p-table [value]="dependentAction?.workflowActionEmails">
                                                                    <ng-template pTemplate="body" let-emailDetails let-index="rowIndex">
                                                                        <tr>
                                                                            <td class="workflow-action-type">
                                                                                {{emailDetails.notificationType==notificationTypeEnum.WHATSAPP ? 'Whatsapp Alert' : 'Email Alert'}} ({{ emailDetails.objectName }})
                                                                            </td>
                                                                            <td style="width: auto">{{ emailDetails.notificationType==notificationTypeEnum.WHATSAPP ? (emailDetails.body | removeHtmlTags | shorten:50) : emailDetails.subject }}</td>
                                                                            <td class="workflow-action-type" class="action p-text-right">

                                                                                <span class="btnBars p-mr-2" (click)="openEmailEdit(addedCondition,'timedependent',i,emailDetails, index)">
                                                                                    <i class="pi pi-eye"></i>
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'workflowActionCreateRecords'">
                                                                <p-table [value]="dependentAction?.workflowActionCreateRecords">
                                                                    <ng-template pTemplate="body" let-recordDetails let-index="rowIndex">
                                                                        <tr>
                                                                            <td class="workflow-action-type">Create Record</td>
                                                                            <td style="width: auto">Module: <strong>{{ recordDetails?.objectName }} {{ recordDetails?.channelName ?'('+recordDetails?.channelName+')':'' }}</strong></td>
                                                                            <td class="workflow-action-type" class="action p-text-right">

                                                                                <span class="btnBars p-mr-2" (click)="openCreateRecordEdit(addedCondition,'timedependent',i,recordDetails, index)">
                                                                                    <i class="pi pi-eye"></i>
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'workflowActionUpdateRecords'">
                                                                <p-table [value]="dependentAction?.workflowActionUpdateRecords">
                                                                    <ng-template pTemplate="body" let-recordDetails let-index="rowIndex">
                                                                        <tr>
                                                                            <td class="workflow-action-type">Update Record ({{ recordDetails.objectName }})</td>
                                                                            <td style="width: auto">Update Type: <strong>{{ workflowUpdateRecordOfferTypes[recordDetails.offerType] }}</strong></td>
                                                                            <td class="workflow-action-type" class="action p-text-right">

                                                                                <span class="btnBars p-mr-2" (click)="openUpdateRecordEdit(addedCondition,'timedependent',i,recordDetails, index)">
                                                                                    <i class="pi pi-eye"></i>
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'workflowActionUpdateFields'">
                                                                <p-table [value]="dependentAction?.workflowActionUpdateFields">
                                                                    <ng-template pTemplate="body" let-fieldDetails let-index="rowIndex">
                                                                        <tr>
                                                                            <td class="workflow-action-type">Update Field ({{fieldDetails?.objectName}})</td>
                                                                            <td style="width: auto">Field: <strong>{{ fieldDetails?.labelName||fieldDetails.fieldName }}</strong> | {{ fieldDetails?.operationType | workflowUFOT }} Value: <strong>{{ fieldDetails | wfUFValue | removeHtmlTags | shorten }}</strong></td>
                                                                            <td class="workflow-action-type" class="action p-text-right">

                                                                                <!-- <span class="btnBars p-mr-2" (click)="openFieldEdit(addedCondition,'timedependent',i,fieldDetails, index)">
                                                                                    <i class="pi pi-eye"></i>
                                                                                </span> -->
                                                                            </td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'workflowActionApprovals'">
                                                                <p-table [value]="dependentAction?.workflowActionApprovals | wfApprovalsGroup">
                                                                    <ng-template pTemplate="body" let-approvalDetails let-index="rowIndex">
                                                                        <tr>
                                                                            <td class="workflow-action-type">Approvals for ({{ approvalDetails.objectName }})</td>
                                                                            <td style="width: auto"><strong>{{ approvalDetails.count }}</strong> Approver Added</td>
                                                                            <td class="workflow-action-type" class="action p-text-right">
                                                                                <span class="btnBars p-mr-2" (click)="openApprovalEdit(addedCondition,'timedependent',i,approvalDetails?.workflowActionApprovals)">
                                                                                    <i class="pi pi-eye"></i>
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'workflowActionConvertToInvoices'">
                                                                <p-table [value]="dependentAction?.workflowActionConvertToInvoices">
                                                                    <ng-template pTemplate="body" let-fieldDetails let-index="rowIndex">
                                                                        <tr>
                                                                            <td class="workflow-action-type">Convert to {{ workflowConversionTypeNames[fieldDetails?.conversionType] }}</td>
                                                                            <td style="width: auto">Action: <strong>{{ fieldDetails.objectName }} Convert to {{ workflowConversionTypeNames[fieldDetails?.conversionType] }}</strong></td>
                                                                            <td class="workflow-action-type" class="action p-text-right"></td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </ng-container>
                                                            <ng-container *ngSwitchCase="'workflowActionDeleteRecords'">
                                                                <p-table [value]="dependentAction?.workflowActionDeleteRecords">
                                                                    <ng-template pTemplate="body" let-fieldDetails let-index="rowIndex">
                                                                        <tr>
                                                                            <td class="workflow-action-type">Delete Records ({{ fieldDetails?.objectName }})</td>
                                                                            <td style="width: auto">Action: <strong>{{ deleteRecordStatusNames[fieldDetails?.changeStatus||0] }} all matched records</strong></td>
                                                                            <td class="workflow-action-type" class="action p-text-right"></td>
                                                                        </tr>
                                                                    </ng-template>
                                                                </p-table>
                                                            </ng-container>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="(addedCondition.timeDependentActions?.length||0)==0">
                            <div class="card p-text-center p-y-2">No Time-Dependent Actions Added!</div>
                        </ng-container>
                    </ng-container>



                </ng-container>
            </p-panel>
        </ng-container>
    </div>
</ng-template>
<!-- Condition Details End -->

<p-dialog header="Action Details" [(visible)]="displayHistoryDetails" (onHide)="historyDialogClose()" [modal]="true" [responsive]="true" [style]="{ width: '60vw' }">
    <div class="card">
        <div class="header p-d-flex p-jc-between" style="position: relative; height: 43px;">
            <h5 class="p-mt-2">Triggered By Condition</h5>
        </div>
        <ng-container *ngTemplateOutlet="conditionDetailsTemplate; context: { conditionGroupDetails: historyConditionGroup, workflowDetailsView: false , filterMode: 'All' }"></ng-container>

        <div class="header p-d-flex p-jc-between" style="position: relative; height: 43px;margin-top: 25px;">
            <h5 class="p-mt-2">Affected

                <ng-container [ngSwitch]="workflowDetails?.objectName">
                    <ng-container *ngSwitchCase="'Opportunity'">
                        Opportunities
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ workflowDetails?.objectName+'s' }}
                    </ng-container>
                </ng-container>

                <span>({{actionHistoryResults?.length||0}})</span>
            </h5>
        </div>

        <div style="padding: 10px;margin-top: 15px;">
            <p-table [value]="actionHistoryResults" [columns]="selectedDetailsCols" responsiveLayout="scroll" styleClass="p-datatable-gridlines">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <ng-container *ngFor="let col of columns">
                            <th *ngIf="col.show" style="min-width: 100px;">
                                {{col.header}}
                            </th>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns">
                    <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                        <ng-container *ngFor="let col of columns">
                            <td *ngIf="col.show" style="text-align: left;min-width: 100px;">
                                <ng-container [ngSwitch]="col?.dataType">
                                    <ng-container *ngSwitchCase="'date'">
                                        <div>
                                            {{ rowData[col.field] | localDate:'MM/DD/YYYY | h:mm a' }}
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'string'">
                                        <span
                                            style="word-break: break-word;"
                                            *ngIf="col?.field?.toLowerCase() === 'description'"
                                            [innerHTML]="rowData[col.field]"
                                            >
                                    </span>
                                        <span class="saved-search-popup-link" style="word-break: break-word;" *ngIf="['name'].includes(col?.value?.toLowerCase())  && col?.field?.toLowerCase() !== 'description'" (click)="onRouteNavigation(rowData,col.field,col.name)">
                                            {{ rowData[col.field] }}
                                        </span>
                                        <span [pTooltip]="rowData[col.field]" style="word-break: break-word;" *ngIf="!(['name'].includes(col?.value?.toLowerCase()))  && col?.field?.toLowerCase() !== 'description'">
                                            {{ rowData[col.field] | shorten:50 }}
                                        </span>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <span [pTooltip]="rowData[col.field]">{{ rowData[col.field] | shorten:50 }}</span>
                                    </ng-container>
                                </ng-container>
                            </td>
                        </ng-container>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="5" style="text-align: center">No Data Found!</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>
    <p-footer>
        <button type="button" pButton (click)="historyDialogClose()" label="Close" class="p-button-secondary"></button>
    </p-footer>
</p-dialog>

<app-shared-detail-popup *ngIf="displayDetailPopup" [moduleType]="popupModuleType" [currentDisplay]="displayDetailPopup" [dataId]="popupDataId" [header]="popupHeader" (dialogClosed)="closeDetailsPopupDialog()">
</app-shared-detail-popup>

<app-workflow-task-add-dialog
    [displayAddTask]="displayAddTask"
    [viewOnly]="true"
    [selectedActionTask]="selectedActionTask"
    [selectedParentModule]="selectedModule"
    (dialogClosed)="displayAddTask=false">
</app-workflow-task-add-dialog>
<app-workflow-email-add-dialog
    *ngIf="displayAddEmailAlert"
    [displayAddEmail]="displayAddEmailAlert"
    [notificationType]="notificationType"
    [viewOnly]="true"
    [selectedActionEmail]="selectedActionEmail"
    [selectedParentModule]="selectedModule"
    [selectedParentTemplate]="selectedTemplate"
    [selectedActionModule]="selectedActionModule"
    (dialogClosed)="displayAddEmailAlert=false">
</app-workflow-email-add-dialog>
<app-workflow-update-field-dialog
    [displayAddField]="displayUpdateField"
    [viewOnly]="true"
    [selectedActionField]="selectedActionField"
    [selectedActionModule]="selectedActionModule"
    [selectedParentModule]="selectedModule"
    [selectedParentTemplate]="selectedTemplate"
    (dialogClosed)="displayUpdateField=false"
>
</app-workflow-update-field-dialog>

<app-workflow-create-record-dialog *ngIf="displayCreateRecord"
    [displayCreateRecordDialog]="displayCreateRecord"
    [viewOnly]="true"
    [selectedParentModule]="selectedModule"
    [selectedActionCreateRecord]="selectedActionRecord"
    (dialogClosed)="displayCreateRecord=false"
>
</app-workflow-create-record-dialog>

<app-workflow-update-record-dialog *ngIf="displayUpdateRecord"
    [displayUpdateRecordDialog]="displayUpdateRecord"
    [viewOnly]="true"
    [selectedActionUpdateRecord]="selectedActionUpdateRecord"
    [selectedParentModule]="selectedModule"
    [selectedActionModule]="selectedActionModule"
    (dialogClosed)="displayUpdateRecord=false"
>
</app-workflow-update-record-dialog>

<app-workflow-approvals-add-dialog *ngIf="displayAddApproval"
    [displayAddApproval]="displayAddApproval"
    [viewOnly]="true"
    [selectedActionApprovals]="selectedActionApprovals"
    [selectedParentModule]="selectedModule"
    [selectedActionModule]="selectedActionModule"
    (dialogClosed)="displayAddApproval=false"
>
</app-workflow-approvals-add-dialog>

<!-- Account Edit Component -->
<app-edit-account *ngIf="displayAccountViewEdit"
    [displayEditViewDialog]="displayAccountViewEdit"
    [displayView]="true"
    [selectedAccountId]="selectedAccountId"
    (closeModal)="closeViewPopup()">
</app-edit-account>

<!-- Lead View/Edit -->
<app-add-update-view-lead *ngIf="displayLeadViewEdit" [display]="true"
    [selectedLeadId]="selectedLeadId"
    [crudType]="'view'"
    (cancelClicked)="closeViewPopup()">
</app-add-update-view-lead>

<!-- Opportunity View/Edit -->
<app-opportunity-add-edit-dialog *ngIf="displayOpportunityViewEdit"
    [displayAddEditDialog]="displayOpportunityViewEdit" [accountChannelId]="workflowDetails?.accountChannelId"
    [opportunityId]="opportunityEditViewId" [crudType]="'view'"
    (closeModal)="closeViewPopup()">
</app-opportunity-add-edit-dialog>

<!-- Inventory Overview -->
<app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber"
    [overviewModule]="inventoryOverviewModule"
    (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>
